import axios from "axios";

export const CUSTOMERS_URL = process.env.REACT_APP_API_BASE_URL + "customer";
export const DELETE_CUSTOMERS_URL =
  process.env.REACT_APP_API_BASE_URL + "customersDelete";
export const CUSTOMERS_FILTERED_URL =
  process.env.REACT_APP_API_BASE_URL + "customersFiltered";

export const CUSTOMERS_DEBT_URL =
  process.env.REACT_APP_API_BASE_URL + "customer-statistics";

// CREATE =>  POST: add a new customer to the server
export function createCustomer(customer) {
  return axios.post(CUSTOMERS_URL, { customer });
}

// READ
export function getAllCustomers() {
  return axios.get(`${CUSTOMERS_URL}`);
}

export function getCustomerById(customerId) {
  return axios.get(`${CUSTOMERS_URL}/${customerId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCustomers(queryParams) {
  if (queryParams == undefined) {
    return axios.get(`${CUSTOMERS_URL}/1/10/null`);
  }

  if (
    queryParams.filter.customerTaxId == undefined ||
    queryParams.filter.customerTaxId == ""
  ) {
    return axios.get(
      `${CUSTOMERS_URL}/${queryParams.pageNumber}/${queryParams.pageSize}/null`
    );
  } else {
    return axios.get(`${CUSTOMERS_URL}/${queryParams.pageNumber}/${queryParams.pageSize}/${queryParams.filter.customerTaxId}`);
  }
}


export function findCustomersDebt(queryParams) {
  let sortField = undefined;
  let sortOrder = undefined;
  let customerName = null;

  if (queryParams != undefined) {
    sortField = queryParams.sortField;
    sortOrder = queryParams.sortOrder;
  }

  if (queryParams.filter != undefined && queryParams.filter.name != undefined) {
    customerName = queryParams.filter.name;
  }
  return axios.get(
    `${CUSTOMERS_DEBT_URL}/${queryParams.pageNumber}/${queryParams.pageSize}/${sortField}/${sortOrder}/${customerName}`
  );
}

// UPDATE => PUT: update the customer on the server
export function updateCustomer(customer) {
  return axios.put(`${CUSTOMERS_URL}/${customer._id}`, { customer });
}

// UPDATE Status
export function updateStatusForCustomers(ids, status) {
  return axios.post(`${CUSTOMERS_URL}/updateStatusForCustomers`, {
    ids,
    status,
  });
}

// DELETE => delete the customer from the server
export function deleteCustomer(customerId) {
  return axios.delete(`${CUSTOMERS_URL}/${customerId}`);
}

// DELETE Customers by ids
export function deleteCustomers(ids) {
  return axios.post(`${DELETE_CUSTOMERS_URL}`, { ids });
}
